import { formatDate } from "@/lib/api";

const L = {
  id: { title:"SURAT JALAN", to:"Penerima", from:"Pengirim", date:"Tanggal", ref:"Ref Invoice", dest:"Tujuan", driver:"Sopir", vehicle:"Kendaraan", no:"No", desc:"Deskripsi", qty:"Qty", notes:"Catatan", receiver:"Penerima", thanks:"Barang di atas telah diterima dengan baik." },
  en: { title:"DELIVERY NOTE", to:"Recipient", from:"Sender", date:"Date", ref:"Invoice Ref", dest:"Destination", driver:"Driver", vehicle:"Vehicle", no:"No", desc:"Description", qty:"Qty", notes:"Notes", receiver:"Receiver", thanks:"Received in good condition." },
};
export const dnT = (lang, k) => (L[lang]||L.id)[k] || k;

export function ClassicDN({ dn, party, owner, settings, logoUrl, font, primary, accent, brandName, lang }) {
  const T = (k) => dnT(lang, k);
  return (
    <div className="max-w-3xl mx-auto p-10 relative" style={{ fontFamily: `"${font}", serif` }}>
      <div className="flex justify-between items-start pb-6 border-b-2" style={{ borderColor: primary }}>
        <div>
          {logoUrl ? <img src={logoUrl} alt="logo" className="h-12 object-contain"/> : <div style={{ backgroundColor: accent }} className="w-10 h-10 flex items-center justify-center font-bold">{brandName.charAt(0).toUpperCase()}</div>}
          <div className="mt-3 text-lg" style={{ fontFamily: font }}>{brandName}</div>
          <div className="text-xs text-forest-400">{owner?.email}</div>
          {settings?.company_address && <div className="text-xs text-forest-400 mt-1 whitespace-pre-line max-w-xs">{settings.company_address}</div>}
          {settings?.company_npwp && <div className="text-xs text-forest-400 font-mono">NPWP: {settings.company_npwp}</div>}
        </div>
        <div className="text-right">
          <div className="text-3xl tracking-tight" style={{ fontFamily: font }}>{T("title")}</div>
          <div className="text-sm num mt-1">{dn.number}</div>
          <div className="text-xs text-forest-400 mt-1">{T("ref")}: {dn.invoice_number}</div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6 py-6 text-sm">
        <div><div className="label-tag mb-1">{T("to")}</div><div className="font-medium">{party?.name || "-"}</div>{party?.address && <div className="text-forest-400 whitespace-pre-line">{party.address}</div>}<div className="mt-2"><span className="text-forest-400">{T("dest")}:</span> {dn.destination||"-"}</div></div>
        <div className="text-right text-sm"><div><span className="text-forest-400">{T("date")}:</span> {formatDate(dn.date)}</div><div><span className="text-forest-400">{T("driver")}:</span> {dn.driver||"-"}</div><div><span className="text-forest-400">{T("vehicle")}:</span> {dn.vehicle||"-"}</div></div>
      </div>
      <table className="w-full text-sm border-t" style={{ borderColor: primary }}>
        <thead><tr className="border-b" style={{ borderColor: primary }}><th className="text-left py-2 label-tag w-12">{T("no")}</th><th className="text-left label-tag">{T("desc")}</th><th className="text-right label-tag">{T("qty")}</th></tr></thead>
        <tbody>{dn.items?.map((it,i)=>(<tr key={i} className="border-b border-forest-100"><td className="py-2 num">{i+1}</td><td>{it.name}</td><td className="text-right num">{it.qty}</td></tr>))}</tbody>
      </table>
      {dn.notes && <div className="mt-4 text-sm"><div className="label-tag mb-1">{T("notes")}</div>{dn.notes}</div>}
      <DNFooter settings={settings} brandName={brandName} lang={lang} driver={dn.driver} party={party}/>
    </div>
  );
}

export function MinimalDN({ dn, party, owner, settings, logoUrl, font, primary, brandName, lang }) {
  const T = (k) => dnT(lang, k);
  return (
    <div className="max-w-3xl mx-auto p-12 relative" style={{ fontFamily: `"${font}", sans-serif` }}>
      <div className="flex items-start justify-between mb-16">
        <div className="text-[10px] uppercase tracking-[0.3em] text-forest-400">{T("title")}</div>
        <div className="text-sm num text-forest-400">{dn.number}</div>
      </div>
      <div className="mb-10">
        <div className="text-4xl mb-1" style={{ fontFamily: font, color: primary }}>{party?.name || "-"}</div>
        <div className="text-sm text-forest-400">{T("dest")} · {dn.destination || "-"} · {formatDate(dn.date)}</div>
      </div>
      <div className="grid grid-cols-3 gap-8 mb-10 text-sm">
        <div><div className="text-[10px] uppercase tracking-[0.3em] text-forest-400 mb-1">{T("ref")}</div><div className="font-medium">{dn.invoice_number}</div></div>
        <div><div className="text-[10px] uppercase tracking-[0.3em] text-forest-400 mb-1">{T("driver")}</div><div className="font-medium">{dn.driver || "-"}</div></div>
        <div><div className="text-[10px] uppercase tracking-[0.3em] text-forest-400 mb-1">{T("vehicle")}</div><div className="font-medium">{dn.vehicle || "-"}</div></div>
      </div>
      <table className="w-full text-sm">
        <thead><tr className="text-[10px] uppercase tracking-[0.2em] text-forest-400"><th className="text-left pb-4 font-normal w-12">{T("no")}</th><th className="text-left pb-4 font-normal">{T("desc")}</th><th className="text-right pb-4 font-normal">{T("qty")}</th></tr></thead>
        <tbody>{dn.items?.map((it,i)=>(<tr key={i}><td className="py-2 num text-forest-400">{i+1}</td><td className="py-2">{it.name}</td><td className="py-2 text-right num">{it.qty}</td></tr>))}</tbody>
      </table>
      {dn.notes && <div className="mt-6 text-sm text-forest-400">{dn.notes}</div>}
      <DNFooter settings={settings} brandName={brandName} lang={lang} driver={dn.driver} party={party} minimal/>
    </div>
  );
}

export function ModernDN({ dn, party, owner, settings, logoUrl, font, primary, accent, brandName, lang }) {
  const T = (k) => dnT(lang, k);
  return (
    <div className="max-w-3xl mx-auto relative" style={{ fontFamily: `"${font}", sans-serif` }}>
      <div className="p-10 text-white" style={{ backgroundColor: primary }}>
        <div className="flex justify-between items-start">
          <div>
            {logoUrl ? <img src={logoUrl} alt="logo" className="h-14 object-contain bg-white/10 p-2 rounded-sm"/> : <div style={{ backgroundColor: accent }} className="w-14 h-14 flex items-center justify-center font-bold text-2xl text-[#151A18]">{brandName.charAt(0).toUpperCase()}</div>}
            <div className="mt-4 text-2xl" style={{ fontFamily: font }}>{brandName}</div>
            <div className="text-xs opacity-70 mt-1">{owner?.email}</div>
            {settings?.company_address && <div className="text-xs opacity-70 mt-1 whitespace-pre-line max-w-xs">{settings.company_address}</div>}
            {settings?.company_npwp && <div className="text-xs opacity-70 font-mono">NPWP: {settings.company_npwp}</div>}
          </div>
          <div className="text-right">
            <div className="text-[10px] uppercase tracking-[0.3em] opacity-70">{T("title")}</div>
            <div className="text-3xl num mt-1" style={{ fontFamily: font }}>{dn.number}</div>
            <div className="text-xs opacity-70 mt-1">{T("ref")}: {dn.invoice_number} · {formatDate(dn.date)}</div>
          </div>
        </div>
      </div>
      <div className="p-10">
        <div className="grid grid-cols-2 gap-6 text-sm mb-8">
          <div className="border-l-4 pl-4" style={{ borderColor: accent }}>
            <div className="text-[10px] uppercase tracking-[0.2em] text-forest-400 mb-1">{T("to")}</div>
            <div className="font-medium text-base">{party?.name || "-"}</div>
            {party?.address && <div className="text-forest-400 mt-1 whitespace-pre-line">{party.address}</div>}
          </div>
          <div className="p-4 rounded-sm" style={{ backgroundColor: primary + "10" }}>
            <div className="grid grid-cols-3 gap-2 text-xs">
              <div><div className="text-forest-400">{T("dest")}</div><div className="font-medium">{dn.destination||"-"}</div></div>
              <div><div className="text-forest-400">{T("driver")}</div><div className="font-medium">{dn.driver||"-"}</div></div>
              <div><div className="text-forest-400">{T("vehicle")}</div><div className="font-medium">{dn.vehicle||"-"}</div></div>
            </div>
          </div>
        </div>
        <table className="w-full text-sm">
          <thead style={{ backgroundColor: primary + "0D" }}><tr><th className="text-left p-3 label-tag w-12" style={{ color: primary }}>{T("no")}</th><th className="text-left p-3 label-tag" style={{ color: primary }}>{T("desc")}</th><th className="text-right p-3 label-tag" style={{ color: primary }}>{T("qty")}</th></tr></thead>
          <tbody>{dn.items?.map((it,i)=>(<tr key={i} className="border-b border-forest-100"><td className="p-3 num">{i+1}</td><td className="p-3">{it.name}</td><td className="p-3 text-right num font-medium">{it.qty}</td></tr>))}</tbody>
        </table>
        {dn.notes && <div className="mt-4 text-sm"><div className="label-tag mb-1">{T("notes")}</div>{dn.notes}</div>}
        <DNFooter settings={settings} brandName={brandName} lang={lang} driver={dn.driver} party={party}/>
      </div>
    </div>
  );
}

function DNFooter({ settings, brandName, lang, driver, party, minimal }) {
  const T = (k) => dnT(lang, k);
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
  const sig = settings?.signature_file_id ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${settings.signature_file_id}?auth=${token}` : null;
  return (
    <div className={`mt-14 grid grid-cols-3 gap-6 text-xs text-center ${minimal?"":"pt-6"}`}>
      <div>
        <div className="mb-14 text-forest-400 uppercase tracking-widest">{T("from")}</div>
        {sig && <img src={sig} alt="sig" className="h-14 object-contain mx-auto mb-1"/>}
        <div className="border-t border-[#151A18] pt-1 font-medium">{settings?.signatory_name || brandName}</div>
        {settings?.signatory_title && <div className="text-forest-400">{settings.signatory_title}</div>}
      </div>
      <div>
        <div className="mb-14 text-forest-400 uppercase tracking-widest">{T("driver")}</div>
        <div className="border-t border-[#151A18] pt-1 font-medium">{driver || "................"}</div>
      </div>
      <div>
        <div className="mb-14 text-forest-400 uppercase tracking-widest">{T("receiver")}</div>
        <div className="border-t border-[#151A18] pt-1 font-medium">{party?.name || "................"}</div>
      </div>
    </div>
  );
}

// ============ CORPORATE DN — sidebar strip, formal ============
export function CorporateDN({ dn, party, owner, settings, logoUrl, font, primary, accent, brandName, lang }) {
  const T = (k) => dnT(lang, k);
  return (
    <div className="max-w-3xl mx-auto flex relative" style={{ fontFamily: `"${font}", serif`, minHeight: "297mm" }}>
      <div className="w-24 flex flex-col items-center py-10" style={{ backgroundColor: primary }}>
        {logoUrl ? <img src={logoUrl} alt="" className="w-16 h-16 object-contain bg-white/10 p-1"/> : <div style={{ backgroundColor: accent }} className="w-16 h-16 flex items-center justify-center font-bold text-2xl text-[#151A18]">{brandName.charAt(0).toUpperCase()}</div>}
        <div className="mt-auto -rotate-90 whitespace-nowrap text-white/60 text-[10px] tracking-[0.4em] uppercase">{brandName}</div>
      </div>
      <div className="flex-1 p-10">
        <div className="flex justify-between items-start pb-6 border-b-2" style={{ borderColor: primary }}>
          <div>
            <div className="text-5xl font-bold" style={{ fontFamily: font, color: primary }}>{T("title")}</div>
            <div className="text-sm num mt-2 text-forest-400">{dn.number}</div>
          </div>
          <div className="text-right text-xs">
            <div><span className="text-forest-400">{T("date")}:</span> {formatDate(dn.date)}</div>
            <div><span className="text-forest-400">{T("ref")}:</span> {dn.invoice_number}</div>
            <div className="inline-block mt-2 px-2 py-1 text-white rounded-sm" style={{ backgroundColor: accent }}>{dn.vehicle || "-"}</div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-6 py-6 text-sm">
          <div>
            <div className="label-tag mb-1" style={{ color: primary }}>{T("from")}</div>
            <div className="font-bold">{brandName}</div>
            {settings?.company_address && <div className="text-forest-400 whitespace-pre-line text-xs">{settings.company_address}</div>}
            {settings?.company_npwp && <div className="text-forest-400 font-mono text-xs">NPWP: {settings.company_npwp}</div>}
          </div>
          <div>
            <div className="label-tag mb-1" style={{ color: primary }}>{T("to")}</div>
            <div className="font-bold">{party?.name || "-"}</div>
            {party?.address && <div className="text-forest-400 whitespace-pre-line text-xs">{party.address}</div>}
            <div className="text-xs mt-1"><span className="text-forest-400">{T("dest")}:</span> {dn.destination||"-"}</div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-3 mb-2 text-xs">
          <div className="border border-forest-100 p-2 rounded-sm"><div className="text-forest-400">{T("driver")}</div><div className="font-medium">{dn.driver || "-"}</div></div>
          <div className="border border-forest-100 p-2 rounded-sm"><div className="text-forest-400">{T("vehicle")}</div><div className="font-medium">{dn.vehicle || "-"}</div></div>
          <div className="border border-forest-100 p-2 rounded-sm"><div className="text-forest-400">{T("date")}</div><div className="font-medium">{formatDate(dn.date)}</div></div>
        </div>
        <table className="w-full text-sm mt-2">
          <thead><tr style={{ backgroundColor: primary, color: "white" }}><th className="text-left p-2 text-xs uppercase tracking-wider w-12">{T("no")}</th><th className="text-left p-2 text-xs uppercase tracking-wider">{T("desc")}</th><th className="text-right p-2 text-xs uppercase tracking-wider">{T("qty")}</th></tr></thead>
          <tbody>{dn.items?.map((it,i)=>(<tr key={i} className="border-b border-forest-100"><td className="p-2 num">{i+1}</td><td className="p-2">{it.name}</td><td className="p-2 text-right num">{it.qty}</td></tr>))}</tbody>
        </table>
        {dn.notes && <div className="mt-4 text-sm"><div className="label-tag mb-1" style={{ color: primary }}>{T("notes")}</div>{dn.notes}</div>}
        <DNFooter settings={settings} brandName={brandName} lang={lang} driver={dn.driver} party={party}/>
      </div>
    </div>
  );
}

// ============ EDITORIAL DN — magazine feel ============
export function EditorialDN({ dn, party, owner, settings, logoUrl, font, primary, brandName, lang }) {
  const T = (k) => dnT(lang, k);
  return (
    <div className="max-w-3xl mx-auto p-14 relative" style={{ fontFamily: `"${font}", Georgia, serif` }}>
      <div className="border-t-4 border-b border-forest-100 py-6 mb-8 flex items-baseline justify-between" style={{ borderTopColor: primary }}>
        <div className="text-[10px] uppercase tracking-[0.4em] text-forest-400">Vol. 1 · {dn.number}</div>
        <div className="text-[10px] uppercase tracking-[0.4em] text-forest-400">{formatDate(dn.date)}</div>
      </div>
      <div className="text-center mb-10">
        <div className="text-6xl leading-none tracking-tight" style={{ fontFamily: font, color: primary }}>{T("title")}</div>
        <div className="mt-4 text-sm text-forest-400 italic max-w-md mx-auto">Dokumen pengiriman resmi dari {brandName} kepada {party?.name || "-"} untuk barang berikut.</div>
      </div>
      <div className="grid grid-cols-3 gap-6 mb-8 text-xs pb-6 border-b border-forest-100">
        <div><div className="uppercase tracking-widest text-forest-400 mb-1">{T("from")}</div><div className="font-bold">{brandName}</div>{settings?.company_address && <div className="text-forest-400 mt-1 whitespace-pre-line">{settings.company_address}</div>}</div>
        <div><div className="uppercase tracking-widest text-forest-400 mb-1">{T("to")}</div><div className="font-bold">{party?.name||"-"}</div>{party?.address && <div className="text-forest-400 mt-1 whitespace-pre-line">{party.address}</div>}</div>
        <div><div className="uppercase tracking-widest text-forest-400 mb-1">{T("dest")}</div><div className="font-bold text-lg" style={{ fontFamily: font }}>{dn.destination||"-"}</div></div>
      </div>
      <div className="grid grid-cols-3 gap-6 mb-6 text-xs">
        <div><div className="uppercase tracking-widest text-forest-400 mb-1">{T("ref")}</div><div className="font-medium">{dn.invoice_number}</div></div>
        <div><div className="uppercase tracking-widest text-forest-400 mb-1">{T("driver")}</div><div className="font-medium">{dn.driver || "-"}</div></div>
        <div><div className="uppercase tracking-widest text-forest-400 mb-1">{T("vehicle")}</div><div className="font-medium">{dn.vehicle || "-"}</div></div>
      </div>
      <table className="w-full text-sm mb-6">
        <tbody>{dn.items?.map((it,i)=>(<tr key={i} className="border-b border-forest-100"><td className="py-3 text-forest-400 num w-8">{String(i+1).padStart(2,"0")}</td><td className="py-3">{it.name}</td><td className="py-3 text-right num font-bold">{it.qty}</td></tr>))}</tbody>
      </table>
      {dn.notes && <div className="text-xs text-forest-400 italic mb-6 border-l-2 pl-3" style={{ borderColor: primary }}>{dn.notes}</div>}
      <DNFooter settings={settings} brandName={brandName} lang={lang} driver={dn.driver} party={party} minimal/>
    </div>
  );
}

export const DN_TEMPLATES = { classic: ClassicDN, minimal: MinimalDN, modern: ModernDN, corporate: CorporateDN, editorial: EditorialDN };
